export default __webpack_public_path__ + "static/media/6.de5368b9.png";